import { CheckInIconStatic } from "../TacticIcons/CheckInIconStatic";

interface CheckInIconAnimatedProps {
  width?: number;
  height?: number;
  className?: string;
  duration?: number;
  color?: string;
  hoverColor?: string;
  strokeWidth?: number;
}

export const CheckInIconAnimated = ({
  width = 24,
  height = 24,
  className,
  duration = 0.5,
  color = "currentColor",
  hoverColor = color,
  strokeWidth = 2
}: CheckInIconAnimatedProps) => {
  const animationAttributes = {
    dur: `${duration * 2}s`,
    begin: "checkInParentGroup.mouseover",
    end: "checkInParentGroup.mouseout",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.42 0 0.58 1; 0.42 0 0.58 1",
    keyTimes: "0; 0.5; 1",
    restart: "whenNotActive"
  } as const;

  return (
    <div className="group">
      {/* Static version - visible by default, hidden on hover */}
      <div
        className={`group-hover:hidden ${className}`}
        style={{ width, height }}
      >
        <CheckInIconStatic
          width={width}
          height={height}
          color={color}
          strokeWidth={strokeWidth}
        />
      </div>

      {/* Animated version - hidden by default, visible on hover */}
      <div
        className={`hidden group-hover:block ${className}`}
        style={{ width, height }}
      >
        <svg
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="checkInParentGroup">
            {/* Invisible rect for hover trigger */}
            <rect
              width="24"
              height="24"
              fill="transparent"
              style={{ cursor: "pointer" }}
            />

            {/* Door frame - stays in place */}
            <path
              d="M15 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H15"
              stroke={color}
              strokeWidth={strokeWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <animate
                attributeName="stroke"
                values={`${color}; ${hoverColor}; ${color}`}
                {...animationAttributes}
              />
            </path>

            {/* Arrow group - slides in from left */}
            <g>
              <animateTransform
                attributeName="transform"
                type="translate"
                values="-3 0; 0 0; -3 0"
                {...animationAttributes}
              />

              {/* Arrow chevron */}
              <path
                d="M10 17L15 12L10 7"
                stroke={color}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <animate
                  attributeName="stroke"
                  values={`${color}; ${hoverColor}; ${color}`}
                  {...animationAttributes}
                />
              </path>

              {/* Arrow line */}
              <path
                d="M15 12H3"
                stroke={color}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <animate
                  attributeName="stroke"
                  values={`${color}; ${hoverColor}; ${color}`}
                  {...animationAttributes}
                />
              </path>
            </g>
          </g>
        </svg>
      </div>
    </div>
  );
};
